import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  const isAuthorized = !!localStorage.getItem('token');

  const handleClick = () => {
    if (isAuthorized) {
      navigate('/admin/home');
    } else {
      navigate('/');
    }
  };

  return (
    <div className="form-container">
      <div className="form-card">
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
          <h1>404 - Not Found</h1>
          <p>The page you are looking for does not exist.</p>
        </div>
        <div className="form-actions">
          <button type="button" className="btn-save" onClick={handleClick}>
            Retour à l'accueil
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
